export default __webpack_public_path__ + "static/media/stroke_icon.8da4a03b.jpg";